import React, { FC } from 'react'
import { STypographyDefault } from '@components/Typography'
import Box from '@components/Box'
import { genders, retirementAges } from '@components/Cacl/data'
import { TGender } from '@components/Cacl/types'
import { SRadio } from '@components/Cacl/Control'
import InputSlider, { FormatType } from '@components/InputSlider'
import { colors } from '@styles/theme'
import { IControlProps } from '@components/CalcAero/types'
import { STopContainer, SContainer, SInputContainer } from './styled'

const Control: FC<IControlProps> = ({
  gender,
  age,
  monthlyPayment,
  period,
  setGender,
  setAge,
  setMonthlyPayment,
  setPeriod,
}) => {
  const retirementAge = retirementAges[gender]

  return (
    <>
      <STypographyDefault mb={{ _: '12px', md: '16px' }} fontWeight="600">
        Ваш пол
      </STypographyDefault>
      <SContainer>
        <STopContainer>
          <Box width={{ md: '124px' }} mb={{ _: '16px', md: 0 }} mr={{ md: '24px' }} height="56px">
            <SRadio
              name="gender"
              values={genders}
              value={gender}
              onChange={(value) => setGender(value as TGender)}
              color={colors.darkBlue}
            />
          </Box>

          <SInputContainer>
            <InputSlider
              min={18}
              max={retirementAge - 1}
              value={age}
              onChange={(value) => setAge(value)}
              label="Ваш возраст"
              aero
              formatType={FormatType.years}
            />
          </SInputContainer>
        </STopContainer>

        <SInputContainer>
          <InputSlider
            min={300}
            max={45000}
            value={monthlyPayment}
            onChange={(value) => setMonthlyPayment(value)}
            label="Ежемесячный взнос"
            aero
            formatType={FormatType.money}
          />
        </SInputContainer>

        <SInputContainer>
          <InputSlider
            min={5}
            max={20}
            value={period}
            onChange={(value) => setPeriod(value)}
            label="Период выплаты пенсии"
            aero
            formatType={FormatType.years}
          />
        </SInputContainer>
      </SContainer>
    </>
  )
}

export default Control
